import Vue from "vue";
import axios from "axios";
import qs from "qs";
import crypto from "crypto";
import store from "@/store";
import { Toast } from "vant";
import Router from "../router";
import Cookies from "js-cookie";
Vue.prototype.axios = axios;

// var origin = "";
// if (window.origin == "http://front.yun.fgcq.info") {
//   origin = "http://api.yun.fgcq.info";
// } else if (window.origin == "https://frontyun.fgcq.info") {
//   origin = "https://frontyunapi.fgcq.info";
// } else if (window.origin == "http://yunoline.fgcq.info") {
//   origin = "http://yunapionline.fgcq.info";
// } else if (window.origin == "http://yunoline.cgodjk.com") {
//   origin = "http://yunapionline.cgodjk.com";
// } else if (window.origin == "https://yunoline.cgodjk.com") {
//   origin = "https://yunapionline.cgodjk.com";
// } else if (window.origin == "http://yunoline-pre.cgodjk.com") {
//   origin = "http://yunapionline-pre.cgodjk.com";
// } else if (window.origin == "https://yunoline-pre.cgodjk.com") {
//   origin = "https://yunapionline-pre.cgodjk.com";
// } else {
//   origin = "/";
// }

// const baseURL = (axios.defaults.baseURL =
//   process.env.NODE_ENV === "development" ? "http://api.yun.fgcq.info" : origin);

const baseURL = process.env.VUE_APP_API_URL;

var seb;
// if (store.getters.ua.isPc) seb = "web";
// if (store.getters.ua.isiOS) seb = "ios";
// if (store.getters.ua.isAndroid) seb = "android";
if (store.getters.ua.isiOS) {
  seb = "ios";
} else if (store.getters.ua.isAndroid) {
  seb = "android";
} else {
  seb = "web";
}

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

const MD5 = (value) => {
  return crypto.createHash("md5").update(value).digest("hex");
};

const sign = (params = {}) => {
  const keys = Object.keys(params).sort();
  const signs = [];
  for (let key of keys) {
    if (params[key] == null) continue;
    signs.push(`${key}=${params[key]}`);
  }
  signs.push(`key=Mjg3NTg0NDI`);
  return MD5(signs.join("&"));
};

const httpRequest = ({ method = "GET", url = "", headers = {} } = {}, body) => {
  const xhr = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    xhr.open(method, baseURL + url, true);
    for (let [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value);
    }
    xhr.onload = ({ target }) => {
      if (target.status == 200 && target.response) {
        resolve(JSON.parse(target.response));
      } else {
        resolve({ msg: xhr.statusText });
      }
    };
    xhr.send(body);
  });
};

const instance = axios.create({
  baseURL,
  timeout: 30000,
  withCredentials: false,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  },
  transformRequest: (data) => qs.stringify(data),
});

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.headers["date"]) {
      store.commit("setServiceTime", response.headers.date);
    }
    if (response.data.code == 4005) {
      setTimeout(() => {
        Router.push("/user/identity");
      }, 1000);
    }
    if (response.status == 200) {
      const data = response.data || {};
      if (data.code == 4003 || data.code == 4001 || data.code == 4004) {
        if (!response.config.skipLogout) {
          store.dispatch("logout", "replace");
        }
      } else if (data.code == 4005) {
        Toast.fail({
          message: "请先完成实名认证",
          onClose: () => {
            Router.push("/user/identity");
          },
        });
      } else if (data.code == 0) {
        if (
          response.config.url != "store/check-order-pay" &&
          response.config.url != "index/popop-ad"
        ) {
          store.dispatch("pushError", data.msg);
        }
      }
      // if (data.code == 4001 || data.code == 4004) {
      //     store.dispatch("logout", "replace");
      //     Router.push('/home')
      // }
      if (data.code == 4006 && response.config.url != "login/logout-login") {
        store.commit("setFeng", data.data);
      }

      if (data.missionMsg) {
        Toast(data.missionMsg);
      }
      return data;
    }

    return {};
  },
  (error) => {
    store.dispatch("pushError", error.toString());
    return Promise.resolve(error);
  }
);

const Ajax = async (url, data = {}, conf = {}) => {
  try {
    const appDeviceInfo = store.state.appdeviceinfo;
    if (typeof appDeviceInfo == "string" && appDeviceInfo.trim()) {
      var channel = JSON.parse(appDeviceInfo).channel;
      var device_brand = JSON.parse(appDeviceInfo).device_brand;
      var idfa = JSON.parse(appDeviceInfo).idfa;
      var version = JSON.parse(appDeviceInfo).version;
      var device_version = JSON.parse(appDeviceInfo).device_version;
      var device_model = JSON.parse(appDeviceInfo).device_model;
      var device_id = JSON.parse(appDeviceInfo).device_id;
      var device_type = JSON.parse(appDeviceInfo).device_type;
    } else {
      var channel = Cookies.get("newPlatId");
      var device_brand = seb;
      var device_id = seb;
      var device_model = "web";
      var device_type = "web";
    }
  } catch (error) {
    var channel = "";
  }
  let accessToken;
  let rs;
  const { auth = true } = conf;
  if (auth) {
    ({ accessToken } = store.getters.state);
  }

  if (accessToken) {
    conf.headers = {
      Authorization: accessToken,
      ...(conf.headers || {}),
    };
  }

  instance.defaults.headers.common["Authorization"] = accessToken;
  var params = {};
  if (accessToken != "") {
    var timestamp = Date.parse(new Date()) / 1000;
    var uuids = uuid();
    const requestId = MD5(accessToken + uuids + timestamp);
    params["requestId"] = requestId;
    params["timestamp"] = timestamp;
  }
  let finalDeviceType = seb;
  if (url === "/order/stream-pushing") {
    finalDeviceType = "h5";
  }
  if (url == "login/get-mobile-login") {
    rs = await instance({
      url,
      method: "post",
      data: {
        ...data,
      },

      ...conf,
    });
    return rs;
  }
  rs = await instance({
    url,
    method: "post",
    data: {
      ...data,
      sign: sign({
        ...data,
        ...params,
        app_id: 1,
        channel,
        device_type:finalDeviceType,
        device_id,
        device_brand,
        idfa,
        version,
        device_version,
        device_model,
      }),
      ...params,
      app_id: 1,
      channel,
      device_type:finalDeviceType,
      device_id,
      device_brand,
      idfa,
      version,
      device_version,
      device_model,
    },

    ...conf,
  });
  return rs;
};

export { baseURL, Ajax, MD5, httpRequest };
export default Ajax;
